import logo from "@/assets/logo.svg";

interface LogoProps {
  className?: string;
}

const Logo = ({ className = "h-8 w-auto" }: LogoProps) => {
  return (
    <img 
      src={logo} 
      alt="Gordon Store Logo" 
      className={className}
    />
  );
};

export default Logo;
